import moment from "moment-timezone";
import { useState } from "react";
import * as changeCase from "change-case";

import Loading from "../../Infrastructure/Loading";
import mergePermits from "../../Helpers/mergePermits";
import { Col, Row } from "react-bootstrap";
import { useLookupPermitQuery } from "../../../Redux/Services/lookupApi";

export default function Permits({ bin }: { bin: string }) {
  const [hideClosedPermits, setHideClosedPermits] = useState(false);
  const { data, isLoading } = useLookupPermitQuery({
    bin,
  });

  if (isLoading) return <Loading />;
  if (!data) return <div>data is undefined</div>;

  const permits = data.data;
  const combinedPermits = mergePermits({
    dobJobs: permits.dobJobs,
    dobnowJobs: permits.dobnowJobs,
    dobnowElecPermits: permits.dobnowElecPermits,
    dobnowLaas: permits.dobnowLaas,
    dobnowAppPermits: permits.dobnowAppPermits,
  });
  if (combinedPermits.length === 0) return <div>No open permits found</div>;
  const signedOffValues = [
    "X SIGNED OFF",
    "Complete: Job is complete",
    "Signed off",
    "LOC Issued",
  ];
  const signedOffPermits = combinedPermits
    .filter((permit) => signedOffValues.includes(permit.status))
    .map((permit) => permit.jobNo);
  return (
    <div>
      <p>Permits filed in NYC Department of Buildings.</p>
      <label>
        <input
          type="checkbox"
          checked={hideClosedPermits}
          onChange={() => setHideClosedPermits(!hideClosedPermits)}
        />{" "}
        Hide closed permits
      </label>
      {combinedPermits.length > 0 && (
        <table>
          <thead>
            <tr>
              <th>Date</th>
              <th>Status</th>
              <th>Job No.</th>
              <th>Description</th>
            </tr>
          </thead>
          <tbody>
            {combinedPermits.map((permit, index) => (
              <tr
                key={index}
                className={
                  signedOffPermits.includes(permit.jobNo) ? "signed-off" : ""
                }
                style={
                  hideClosedPermits && signedOffPermits.includes(permit.jobNo)
                    ? { display: "none" }
                    : {}
                }
              >
                <td>{moment.unix(permit.date).format("YYYY-MM-DD")}</td>
                <td>{changeCase.capitalCase(permit.status)}</td>
                <td>
                  {permit.source}
                  {permit.jobNo ? <br /> : ""}
                  {permit.jobNo}
                  {permit.jobType ? <br /> : ""}
                  {permit.jobType}
                </td>
                <td className="smaller">{permit.description}</td>
                <td className="mobile-only">
                  <Row>
                    <Col xs={6}>
                      <dt>Date</dt>
                      <dd>{moment.unix(permit.date).format("YYYY-MM-DD")}</dd>
                      <dt>Status</dt>
                      <dd>{changeCase.capitalCase(permit.status)}</dd>
                    </Col>
                    <Col xs={6}>
                      <dt>Source / Job Info</dt>
                      <dd>
                        {permit.source}
                        {permit.jobNo ? <br /> : ""}
                        {permit.jobNo}
                        {permit.jobType ? <br /> : ""}
                        {permit.jobType}
                      </dd>
                    </Col>
                    {permit.description !== "" && (
                      <Col xs={12}>
                        <dt>Description</dt>
                        <dd>{permit.description}</dd>
                      </Col>
                    )}
                  </Row>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
